import { useEffect, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { registerWalletGateHost } from "../../utils/walletGate";
import { startWalletTopUp } from "../../utils/walletTopUp";
import { LowBalanceSheet, PaidCallSheet, TopUpResultSheet, LastFreeSheet, OwnTargetSheet, CallFailedSheet } from "./WalletSheets";

/* Mounted once in App. When a call needs the customer's agreement or money first,
   callWithWalletGate asks here and waits for "call" or "cancel". */
export default function WalletGateHost() {
  const { t, lang } = useLanguage();
  const { user } = useAuth();
  const [gate, setGate] = useState(null);

  useEffect(() => registerWalletGateHost((detail) => new Promise((resolve) => {
    setGate({ ...detail, resolve, stage: "ask", busy: false, result: null });
  })), []);

  if (!gate) return null;
  const finish = (answer) => { gate.resolve(answer); setGate(null); };

  if (gate.stage === "result") {
    return (
      <TopUpResultSheet t={t} result={gate.result}
        successLabel={t("wg_callNow")}
        onSuccess={() => finish("call")}
        onRetry={() => setGate((g) => ({ ...g, stage: "ask", result: null }))}
        onClose={() => finish("cancel")} />
    );
  }

  if (gate.kind === "paid") {
    return <PaidCallSheet t={t} lang={lang} fee={gate.fee} balance={gate.balance} resetsAt={gate.resetsAt} free={gate.free} hours={gate.hours}
      onCall={() => finish("call")} onCancel={() => finish("cancel")} />;
  }
  // App calls (mock AppCall_3): the last free call, and a driver's own car or profile.
  if (gate.kind === "last") {
    return <LastFreeSheet t={t} lang={lang} free={gate.free} resetsAt={gate.resetsAt} onCall={() => finish("call")} onCancel={() => finish("cancel")} />;
  }
  if (gate.kind === "own") return <OwnTargetSheet t={t} driver={gate.driver} onClose={() => finish("cancel")} />;
  if (gate.kind === "failed") return <CallFailedSheet t={t} onClose={() => finish("cancel")} />;

  const addMoney = async (amount) => {
    setGate((g) => ({ ...g, busy: true }));
    const result = await startWalletTopUp({ amount, user });
    if (result.status === "cancelled") { setGate((g) => ({ ...g, busy: false })); return; }
    setGate((g) => ({ ...g, busy: false, stage: "result", result, balance: result.balance ?? g.balance }));
  };

  return (
    <LowBalanceSheet t={t} lang={lang} fee={gate.fee} balance={gate.balance} resetsAt={gate.resetsAt} free={gate.free} hours={gate.hours}
      busy={gate.busy} onAdd={addMoney} onCancel={() => finish("cancel")} />
  );
}
